<template>
  <div class="home" v-if="app != null && app.data != null">
    <div id="format-incorrect">Votre appareil n'est pas compatible.</div>

    <div id="launcher" class="launcher">
      <img src="logo.png" id="logo" />
      <h1>Voir</h1>
      <h2>Un jeu pour s'amuser<br />au musée</h2>
      <div>
        <button @click="app.close">Commencer</button>
      </div>
      <h4 style="font-weight: 400">Offert par</h4>

      <img src="adm_logo.png" id="logos" />
      <img src="troyes_logo.png" id="logos" />
      <img src="musees_logo_generique_noir.jpg" id="logos" />
      <div id="footer">
        <p>Vous aimez les musées ?</p>
        <p>Venez les soutenir en rejoignant les Amis.</p>
        <a
          href="https://www.musees-troyes.com/partenaires-et-mecenes/amis-des-musees-dart-et-dhistoire/"
          ><blockquote>Renseignements ici</blockquote></a
        >
      </div>
    </div>

    <level v-bind:app="app"></level>
  </div>
</template>

<script>
import level from "./level.vue";

export default {
  name: "HomeVue",
  props: {
    app: Object,
  },
  components: {
    level,
  },
};
</script>
